export default {
  DeptCode: "",
  Description: "",
  CategoryId: null,
  DefaultAccount: "",
  UserModified: localStorage.getItem("UserName"),
};
